import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { string } from "yup";
import FormikControls from "./form-components/FormikControls";
import { Preview } from "@mui/icons-material";
import { navigation1, navigation3 } from "../../../utilityFunctions";
const LoginForm = (props) => {
    const { setHeading, fetchLogin, error, setError, termCondition, setShowDeleteModal, setLoginId, setShowLoginId } = props;
    const [isLoading, setIsloading] = useState(false);
    // const [OTP, setOTP] = useState(false);
    const [loginError, setLoginError] = useState("");
    const location = useLocation();
    let from = location.state?.from?.pathname || "/";
    const initialValues = {
        // loginFor: "B",
        // Code: "",
        LoginID: "",
        Password: "",
        ODP: "0"
    };
    // useEffect(() => {
    //     if (window.location.pathname.toLocaleLowerCase() === "/cargo") {
    //         initialValues.loginFor = "C";
    //         setHeading("Cargo BusCRS");
    //     }
    // }, []);

    const validationSchema = Yup.object({
        // loginFor: Yup.string().required("required"),
        // Code: Yup.string().required("Required"),
        LoginID: Yup.string()
            .transform((value) => value.toUpperCase())
            .required("Required"),
        Password: string().required("Required"),
        ODP: string().required("Required")
    });
    const handlePlatformChange = (e, setFieldValue) => {
        setFieldValue("loginFor", e.currentTarget.value);
    };
    const onSubmit = async (values) => {
        if (!termCondition && values) {
            setShowDeleteModal(true)
        } else {
            fetchLogin(values)
            setError((pre) => ({ ...Preview, value: false, msg: false }))
            // if (OTP) {
            //     fetchLogin(values)
            // } else {
            //     setOTP(true)
            // }
            // window.location.replace(getRedirectUrl(values));
            return false;
        }
    };

    return (
        <div className="login--content">
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({ values, setFieldValue, submitForm }) => {
                    return (
                        <Form>
                            {isLoading && (
                                <div className="form-error">
                                    Authenticating...{" "}
                                </div>
                            )}
                            {loginError !== "" && !isLoading && (
                                <div className="form-error">{loginError}</div>
                            )}
                            <div className="input--wrapper">
                                <FormikControls
                                    control="input"
                                    type="text"
                                    name="LoginID"
                                    id='LoginID'
                                    label="User ID"
                                    autoFocus={true}
                                    autoComplete="off"
                                    onBlur={(e) => { setLoginId(e.target.value); setShowLoginId(e.target.value) }}
                                    onChange={(e) => setFieldValue("LoginID", e.target.value.toUpperCase())}
                                    onKeyDown={(e) => {
                                        navigation1(e, 'password', 'submit')
                                    }}

                                />
                            </div>
                            <div className="input--wrapper">
                                <FormikControls
                                    control="input"
                                    type="password"
                                    id='password'
                                    name="Password"
                                    label="Profile Password"
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        if (e.keyCode === 13) submitForm();
                                    }}
                                />
                            </div>
                            {/* <div className="input--wrapper">
                                <FormikControls
                                    control="input"
                                    type="password"
                                    name="ODP"
                                    id='ODP'
                                    label="One Day Password (ODP)"
                                    autoComplete="off"
                                    onKeyDown={(e) => {
                                        navigation1(e, 'submit', 'password')
                                    }}
                                //disabled={true}
                                />
                            </div> */}
                            {/* {
                                OTP &&
                                <>
                                    <div className="input--wrapper">
                                        <FormikControls
                                            control="input"
                                            type="text"
                                            name="ODP"
                                            label="ODP (One Day Password)"
                                            autoComplete="off"
                                            onKeyUp={(e) => {
                                                if (e.keyCode === 13) submitForm();
                                            }}
                                        />
                                    </div>
                                    <div className="forgotPassText">
                                        <span>Resend ODP </span>
                                    </div>
                                </>
                            } */}
                            {/* {
                                error && error?.value && <div className="error" >{error.masg || error.msg}</div>
                            } */}
                            <div
                                className="submit--btn"
                                onClick={(e) => {
                                    submitForm();
                                }}
                                tabIndex={0}
                                id='submit'
                                type="submit"
                                onKeyDown={(e) => {
                                    navigation3(e, 'LoginID', 'ODP', () => { submitForm() })
                                }}
                            >
                                LOGIN
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default LoginForm;
